// extracted by mini-css-extract-plugin
export var buttons = "_am-0";
export var buttonsActive = "_am-h";
export var cancelConfirm = "_am-1";
export var closeButton = "_am-2";
export var column = "_am-3";
export var container = "_am-4";
export var detailHeader = "_am-6";
export var detailTitle = "_am-7";
export var detailsContent = "_am-5";
export var header = "_am-8";
export var headerWithClose = "_am-9";
export var icon = "_am-a";
export var infoIcon = "_am-c";
export var informationContainer = "_am-b";
export var sideDrawer = "_am-d";
export var sideDrawerOpen = "_am-e";
export var stickyFooter = "_am-f";
export var typeOption = "_am-g";